var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property, Complex } from '@syncfusion/ej2-base';
/**
 * Represents the cell style.
 */
export class CellStyle extends ChildProperty {
}
__decorate([
    Property('Calibri')
], CellStyle.prototype, "fontFamily", void 0);
__decorate([
    Property('bottom')
], CellStyle.prototype, "verticalAlign", void 0);
__decorate([
    Property('left')
], CellStyle.prototype, "textAlign", void 0);
__decorate([
    Property('0pt')
], CellStyle.prototype, "textIndent", void 0);
__decorate([
    Property('#000000')
], CellStyle.prototype, "color", void 0);
__decorate([
    Property('#ffffff')
], CellStyle.prototype, "backgroundColor", void 0);
__decorate([
    Property('normal')
], CellStyle.prototype, "fontWeight", void 0);
__decorate([
    Property('normal')
], CellStyle.prototype, "fontStyle", void 0);
__decorate([
    Property('11pt')
], CellStyle.prototype, "fontSize", void 0);
__decorate([
    Property('none')
], CellStyle.prototype, "textDecoration", void 0);
__decorate([
    Property('')
], CellStyle.prototype, "border", void 0);
__decorate([
    Property('')
], CellStyle.prototype, "borderTop", void 0);
__decorate([
    Property('')
], CellStyle.prototype, "borderBottom", void 0);
__decorate([
    Property('')
], CellStyle.prototype, "borderLeft", void 0);
__decorate([
    Property('')
], CellStyle.prototype, "borderRight", void 0);
/**
 * Represents the Filter Collection.
 *
 */
export class FilterCollection extends ChildProperty {
}
__decorate([
    Property()
], FilterCollection.prototype, "sheetIndex", void 0);
__decorate([
    Property()
], FilterCollection.prototype, "filterRange", void 0);
__decorate([
    Property(false)
], FilterCollection.prototype, "hasFilter", void 0);
__decorate([
    Property()
], FilterCollection.prototype, "column", void 0);
__decorate([
    Property()
], FilterCollection.prototype, "criteria", void 0);
__decorate([
    Property()
], FilterCollection.prototype, "value", void 0);
__decorate([
    Property()
], FilterCollection.prototype, "dataType", void 0);
__decorate([
    Property()
], FilterCollection.prototype, "predicates", void 0);
/**
 * Represents the sort Collection.
 *
 */
export class SortCollection extends ChildProperty {
}
__decorate([
    Property()
], SortCollection.prototype, "sortRange", void 0);
__decorate([
    Property()
], SortCollection.prototype, "columnIndex", void 0);
__decorate([
    Property()
], SortCollection.prototype, "order", void 0);
__decorate([
    Property()
], SortCollection.prototype, "sheetIndex", void 0);
/**
 * Represents a defined name in the spreadsheet.
 * A defined name is a meaningful identifier that refers to a specific cell or range, and can be used in formulas.
 */
export class DefineName extends ChildProperty {
}
__decorate([
    Property('')
], DefineName.prototype, "name", void 0);
__decorate([
    Property('')
], DefineName.prototype, "scope", void 0);
__decorate([
    Property('')
], DefineName.prototype, "comment", void 0);
__decorate([
    Property('')
], DefineName.prototype, "refersTo", void 0);
/**
 * Configures the Protect behavior for the spreadsheet.
 *
 */
export class ProtectSettings extends ChildProperty {
}
__decorate([
    Property(false)
], ProtectSettings.prototype, "selectCells", void 0);
__decorate([
    Property(false)
], ProtectSettings.prototype, "selectUnLockedCells", void 0);
__decorate([
    Property(false)
], ProtectSettings.prototype, "formatCells", void 0);
__decorate([
    Property(false)
], ProtectSettings.prototype, "formatRows", void 0);
__decorate([
    Property(false)
], ProtectSettings.prototype, "formatColumns", void 0);
__decorate([
    Property(false)
], ProtectSettings.prototype, "insertLink", void 0);
/**
 * Represents the Hyperlink.
 *
 */
export class Hyperlink extends ChildProperty {
}
__decorate([
    Property('')
], Hyperlink.prototype, "address", void 0);
/**
 * Represents the DataValidation.
 */
export class Validation extends ChildProperty {
}
__decorate([
    Property('WholeNumber')
], Validation.prototype, "type", void 0);
__decorate([
    Property('Between')
], Validation.prototype, "operator", void 0);
__decorate([
    Property('0')
], Validation.prototype, "value1", void 0);
__decorate([
    Property('0')
], Validation.prototype, "value2", void 0);
__decorate([
    Property(true)
], Validation.prototype, "ignoreBlank", void 0);
__decorate([
    Property(true)
], Validation.prototype, "inCellDropDown", void 0);
__decorate([
    Property(false)
], Validation.prototype, "isHighlighted", void 0);
__decorate([
    Property('')
], Validation.prototype, "address", void 0);
/**
 * Represents the Format.
 */
export class Format extends ChildProperty {
}
__decorate([
    Property('General')
], Format.prototype, "format", void 0);
__decorate([
    Complex({}, CellStyle)
], Format.prototype, "style", void 0);
__decorate([
    Property(true)
], Format.prototype, "isLocked", void 0);
/**
 * Represents the Conditional Formatting.
 *
 */
export class ConditionalFormat extends ChildProperty {
}
__decorate([
    Property('GreaterThan')
], ConditionalFormat.prototype, "type", void 0);
__decorate([
    Complex({}, Format)
], ConditionalFormat.prototype, "format", void 0);
__decorate([
    Property('RedFT')
], ConditionalFormat.prototype, "cFColor", void 0);
__decorate([
    Property('')
], ConditionalFormat.prototype, "value", void 0);
__decorate([
    Property('')
], ConditionalFormat.prototype, "range", void 0);
__decorate([
    Property('')
], ConditionalFormat.prototype, "action", void 0);
/**
 * Represents the Legend.
 *
 */
export class LegendSettings extends ChildProperty {
}
__decorate([
    Property(true)
], LegendSettings.prototype, "visible", void 0);
__decorate([
    Property('Auto')
], LegendSettings.prototype, "position", void 0);
/**
 * Represents the DataLabelSettings.
 *
 */
export class DataLabelSettings extends ChildProperty {
}
__decorate([
    Property(false)
], DataLabelSettings.prototype, "visible", void 0);
__decorate([
    Property('Auto')
], DataLabelSettings.prototype, "position", void 0);
/**
 * Represents the Border.
 *
 */
export class Border extends ChildProperty {
}
__decorate([
    Property('')
], Border.prototype, "color", void 0);
__decorate([
    Property(1)
], Border.prototype, "width", void 0);
/**
 * Represents the MarkerSettings.
 *
 */
export class MarkerSettings extends ChildProperty {
}
__decorate([
    Property(false)
], MarkerSettings.prototype, "visible", void 0);
__decorate([
    Property('Circle')
], MarkerSettings.prototype, "shape", void 0);
__decorate([
    Property(5)
], MarkerSettings.prototype, "size", void 0);
__decorate([
    Property(null)
], MarkerSettings.prototype, "fill", void 0);
__decorate([
    Property(true)
], MarkerSettings.prototype, "isFilled", void 0);
__decorate([
    Complex({}, Border)
], MarkerSettings.prototype, "border", void 0);
/**
 * Specifies the major grid lines in the `axis`.
 *
 */
export class MajorGridLines extends ChildProperty {
}
__decorate([
    Property(0)
], MajorGridLines.prototype, "width", void 0);
/**
 * Specifies the minor grid lines in the `axis`.
 *
 */
export class MinorGridLines extends ChildProperty {
}
__decorate([
    Property(0)
], MinorGridLines.prototype, "width", void 0);
/**
 * Represents the axis.
 *
 */
export class Axis extends ChildProperty {
}
__decorate([
    Property('')
], Axis.prototype, "title", void 0);
__decorate([
    Complex({}, MajorGridLines)
], Axis.prototype, "majorGridLines", void 0);
__decorate([
    Complex({}, MinorGridLines)
], Axis.prototype, "minorGridLines", void 0);
__decorate([
    Property(true)
], Axis.prototype, "visible", void 0);
/**
 * Represents the Chart.
 */
export class Chart extends ChildProperty {
}
__decorate([
    Property('Line')
], Chart.prototype, "type", void 0);
__decorate([
    Property('Material')
], Chart.prototype, "theme", void 0);
__decorate([
    Property(false)
], Chart.prototype, "isSeriesInRows", void 0);
__decorate([
    Complex({}, MarkerSettings)
], Chart.prototype, "markerSettings", void 0);
__decorate([
    Property('')
], Chart.prototype, "range", void 0);
__decorate([
    Property('')
], Chart.prototype, "id", void 0);
__decorate([
    Property('')
], Chart.prototype, "title", void 0);
__decorate([
    Property(290)
], Chart.prototype, "height", void 0);
__decorate([
    Property(480)
], Chart.prototype, "width", void 0);
__decorate([
    Property(0)
], Chart.prototype, "top", void 0);
__decorate([
    Property(0)
], Chart.prototype, "left", void 0);
__decorate([
    Complex({}, LegendSettings)
], Chart.prototype, "legendSettings", void 0);
__decorate([
    Complex({}, Axis)
], Chart.prototype, "primaryXAxis", void 0);
__decorate([
    Complex({}, Axis)
], Chart.prototype, "primaryYAxis", void 0);
__decorate([
    Complex({}, DataLabelSettings)
], Chart.prototype, "dataLabelSettings", void 0);
/**
 * Represents the Image.
 */
export class Image extends ChildProperty {
}
__decorate([
    Property('')
], Image.prototype, "src", void 0);
__decorate([
    Property('')
], Image.prototype, "id", void 0);
__decorate([
    Property(300)
], Image.prototype, "height", void 0);
__decorate([
    Property(400)
], Image.prototype, "width", void 0);
__decorate([
    Property(0)
], Image.prototype, "top", void 0);
__decorate([
    Property(0)
], Image.prototype, "left", void 0);
/**
 * Represents the AutoFillSettings.
 */
export class AutoFillSettings extends ChildProperty {
}
__decorate([
    Property('FillSeries')
], AutoFillSettings.prototype, "fillType", void 0);
__decorate([
    Property(true)
], AutoFillSettings.prototype, "showFillOptions", void 0);
